import React, { PureComponent } from "react";
import moment from "moment";
import isNil from "lodash/isNil";

import { TextField as MuiTextField, MenuItem } from "@material-ui/core";

export default class TextField extends PureComponent {
  render() {
    const {
      input,
      margin,
      select,
      variant,
      children,
      formatDate,
      defaultValue,
      noResultsMessage,
      ...rest
    } = this.props;
    const { onChange, value } = input;

    return (
      <MuiTextField
        select={select}
        margin={margin}
        variant={variant}
        value={
          moment.isMoment(value)
            ? formatDate(value)
            : isNil(value)
            ? defaultValue
            : value
        }
        onChange={input ? onChange : undefined}
        {...rest}
      >
        {children}
        {select && !React.Children.count(children) && (
          <MenuItem disabled>{noResultsMessage}</MenuItem>
        )}
      </MuiTextField>
    );
  }
}

TextField.defaultProps = {
  fullWidth: true,
  margin: "normal",
  variant: "standard",
  noResultsMessage: "Empty",
};
